/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { Typography } from '@material-ui/core';

const Row = ({ label, text }) => (
  <div className="save row">
    <div className="save-label">
      <Typography variant="h6">{label}</Typography>
    </div>
    <div className="save-text">
      <Typography>{text}</Typography>
    </div>
  </div>
);

export default Row;
